import { IBalusterGeometry, IRailingConfig, IRailingGeometry } from '@stair-craft/common/util';

import { balusterCount } from '../shared-baluster-count/baluster-count';

/** A single straight railing segment running radially from `innerR` to `outerR` at a fixed angle. */
export function buildRadialRailing(
    cx: number,
    cz: number,
    angle: number,
    innerR: number,
    outerR: number,
    y: number,
    rc: IRailingConfig
): IRailingGeometry {
    const len: number = outerR - innerR;
    const balCount: number = balusterCount(len, rc);
    const balusters: IBalusterGeometry[] = [];
    for (let i: number = 1; i < balCount; i++) {
        const r: number = innerR + (len * i) / balCount;
        balusters.push({
            position: { y, x: cx + r * Math.sin(angle), z: cz + r * Math.cos(angle) },
            height: rc.height,
            rotation: 0,
        });
    }

    return {
        balusters,
        side: 'right',
        handrail: {
            points: [
                { x: cx + innerR * Math.sin(angle), y: y + rc.height, z: cz + innerR * Math.cos(angle) },
                { x: cx + outerR * Math.sin(angle), y: y + rc.height, z: cz + outerR * Math.cos(angle) },
            ],
            width: rc.handrailWidth,
            height: rc.handrailHeight,
        },
        posts: [
            {
                position: { y, x: cx + innerR * Math.sin(angle), z: cz + innerR * Math.cos(angle) },
                height: rc.height,
                rotation: 0,
            },
            {
                position: { y, x: cx + outerR * Math.sin(angle), z: cz + outerR * Math.cos(angle) },
                height: rc.height,
                rotation: 0,
            },
        ],
        balusterWidth: rc.balusterWidth,
        postWidth: rc.postWidth,
    };
}
